import { Component, OnDestroy } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeWhile } from 'rxjs';
import { Router } from '@angular/router';

import { EntitiesService, IEntity } from '@app/core/entities';
import { EntityDialogComponent } from '../entity-dialog/entity-dialog.component';
import { YesNoDialogComponent } from '@app/shared';

@Component({
  selector: 'app-entity-list',
  templateUrl: './entity-list.component.html',
})
export class EntityListComponent implements OnDestroy {
  public records$: Subject<IEntity[]>;
  public selectedRecords: IEntity[];

  private destroyed: boolean;

  constructor(
    private service: EntitiesService,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.records$ = new Subject();
    this.loadRecords();
  }

  private loadRecords(): void {
    this.selectedRecords = [];

    this.service
      .getEntities()
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((records) => {
        this.records$.next(records);
      });
  }

  public onRowEdit(record: IEntity): void {
    this.router.navigate(['/entities', record.id]);
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar usuario/s',
        data: {
          message: '¿Eliminar usuarios seleccionados?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteEntity(this.selectedRecords.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.loadRecords();
            });
        }
      });
  }

  public newRecord(): void {
    this.dialogService
      .open(EntityDialogComponent, {
        height: '600px',
        width: '800px',
        header: 'Nueva entidad',
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((record) => {
        if (record) {
          this.loadRecords();
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
